function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

import { objectSpread2 as _objectSpread2, initializerDefineProperty as _initializerDefineProperty, applyDecoratedDescriptor as _applyDecoratedDescriptor } from "../_virtual/_rollupPluginBabelHelpers.js";
import { observable, computed, action } from 'mobx';
import groupBy from 'lodash.groupby';

var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _class2, _temp;

var AUTOFILL_FIELD_DATA = {
  dataType: 'autofill',
  value: '',
  sourceKey: '',
  valueType: 'string',
  label: '',
  fontSize: undefined,
  defaultWidth: 120,
  defaultHeight: 20
};
var MANUAL_FIELD_DATA = {
  dataType: 'manual',
  value: '',
  valueType: 'string',
  label: 'Custom Field',
  parties: [],
  fontSize: undefined,
  defaultWidth: 120,
  defaultHeight: 20
};
var MANUAL_DATE_FIELD_DATA = {
  dataType: 'manual',
  value: '',
  sourceKey: 'dateSigned',
  valueType: 'date',
  label: 'Date Signed',
  parties: [],
  fontSize: undefined,
  defaultWidth: 120,
  defaultHeight: 20,
  group: 'Other'
};
var CHECKBOX_FIELD_DATA = {
  dataType: 'manual',
  value: false,
  valueType: 'boolean',
  label: 'Custom Field',
  parties: [],
  fontSize: undefined,
  defaultWidth: 10,
  defaultHeight: 10
};
var SIGNATURE_FIELD_DATA = {
  dataType: 'signing',
  value: '',
  valueType: 'signature',
  label: 'Signature Field',
  parties: [],
  fontSize: undefined,
  defaultWidth: 120,
  defaultHeight: 20
};
var INITIALS_FIELD_DATA = {
  dataType: 'signing',
  value: '',
  valueType: 'initials',
  label: 'Initials Field',
  parties: [],
  fontSize: undefined,
  defaultWidth: 40,
  defaultHeight: 20
};
var fieldData = {
  textfield: MANUAL_FIELD_DATA,
  autofill: AUTOFILL_FIELD_DATA,
  signature: SIGNATURE_FIELD_DATA,
  initials: INITIALS_FIELD_DATA,
  checkbox: CHECKBOX_FIELD_DATA
};

var getFieldData = function getFieldData(mode) {
  return _objectSpread2({}, fieldData[mode]);
};

var AnnotationField = (_class = (_temp = _class2 = /*#__PURE__*/function () {
  function AnnotationField(values) {
    var _this = this;

    _classCallCheck(this, AnnotationField);

    this.id = void 0;

    _initializerDefineProperty(this, "x", _descriptor, this);

    _initializerDefineProperty(this, "y", _descriptor2, this);

    _initializerDefineProperty(this, "width", _descriptor3, this);

    _initializerDefineProperty(this, "height", _descriptor4, this);

    _initializerDefineProperty(this, "page", _descriptor5, this);

    _initializerDefineProperty(this, "data", _descriptor6, this);

    _initializerDefineProperty(this, "autoscaleFontSize", _descriptor7, this);

    _initializerDefineProperty(this, "fontSizeOptions", _descriptor8, this);

    _initializerDefineProperty(this, "updateData", _descriptor9, this);

    _initializerDefineProperty(this, "updateAttributes", _descriptor10, this);

    _initializerDefineProperty(this, "setFontSize", _descriptor11, this);

    _initializerDefineProperty(this, "setAutoscaleFontSize", _descriptor12, this);

    _initializerDefineProperty(this, "setFontSizeOptions", _descriptor13, this);

    this.containsPoint = function (_ref) {
      var x = _ref.x,
          y = _ref.y;
      var topY = _this.y;
      var bottomY = _this.y + _this.height;
      var leftX = _this.x;
      var rightX = _this.x + _this.width;
      return x >= leftX && x <= rightX && y >= topY && y <= bottomY;
    };

    this.findParty = function (userId, userPermissions) {
      if (_this.data.dataType === 'autofill') return undefined;
      var party;

      if (userId) {
        party = _this.data.parties.find(function (p) {
          return p.userId === userId;
        });
      }

      if (!party && userPermissions) {
        party = _this.data.parties.find(function (p) {
          return p.permission && userPermissions.includes(p.permission);
        });
      }

      return party;
    };

    this.belongsTo = function (userId, userPermissions) {
      return !!_this.findParty(userId, userPermissions);
    };

    this.id = values.id;
    this.x = values.x;
    this.y = values.y;
    this.width = values.width;
    this.height = values.height;
    this.page = values.page;

    if (values.data) {
      this.data = values.data;
    }
  }

  _createClass(AnnotationField, [{
    key: "fontSize",
    get: function get() {
      var _this$data$fontSize;

      return (_this$data$fontSize = this.data.fontSize) !== null && _this$data$fontSize !== void 0 ? _this$data$fontSize : this.autoscaleFontSize;
    }
  }, {
    key: "setData",
    value: function setData(data) {
      this.data = data || MANUAL_FIELD_DATA;
    }
  }]);

  return AnnotationField;
}(), _class2.getAssignedFields = function () {
  var fields = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var userId = arguments.length > 1 ? arguments[1] : undefined;
  var userPermissions = arguments.length > 2 ? arguments[2] : undefined;
  return fields.filter(function (field) {
    return field.belongsTo(userId, userPermissions);
  });
}, _class2.groupFieldsByDataType = function () {
  var fields = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var userId = arguments.length > 1 ? arguments[1] : undefined;
  var userPermissions = arguments.length > 2 ? arguments[2] : undefined;
  var fieldsWithValueOnly = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

  if (userId || userPermissions) {
    fields = AnnotationField.getAssignedFields(fields, userId, userPermissions);
  }

  if (fieldsWithValueOnly) {
    fields = fields.filter(function (field) {
      return field.data.value;
    });
  }

  return _objectSpread2({
    autofill: [],
    manual: [],
    signing: []
  }, groupBy(fields, function (field) {
    return field.data.dataType;
  }));
}, _temp), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "x", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "y", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "width", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "height", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "page", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "data", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return MANUAL_FIELD_DATA;
  }
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "autoscaleFontSize", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "fontSizeOptions", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return [];
  }
}), _applyDecoratedDescriptor(_class.prototype, "fontSize", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "fontSize"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setData", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setData"), _class.prototype), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "updateData", [action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this2 = this;

    return function (data) {
      _extends(_this2.data, data);
    };
  }
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "updateAttributes", [action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this3 = this;

    return function (values) {
      _extends(_this3, values);
    };
  }
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "setFontSize", [action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this4 = this;

    return function (size) {
      _this4.data.fontSize = size;
      _this4.autoscaleFontSize = size;
    };
  }
}), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "setAutoscaleFontSize", [action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this5 = this;

    return function (size) {
      _this5.autoscaleFontSize = size;
    };
  }
}), _descriptor13 = _applyDecoratedDescriptor(_class.prototype, "setFontSizeOptions", [action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this6 = this;

    return function (fontSizeOptions) {
      _this6.fontSizeOptions = fontSizeOptions;
    };
  }
})), _class);
export default AnnotationField;
export { AUTOFILL_FIELD_DATA, CHECKBOX_FIELD_DATA, INITIALS_FIELD_DATA, MANUAL_DATE_FIELD_DATA, MANUAL_FIELD_DATA, SIGNATURE_FIELD_DATA, fieldData, getFieldData };